import React from 'react';

export const Breadcrumb = ({ children, className = '', ...props }) => {
  return (
    <nav aria-label="breadcrumb" className={className} {...props}>
      <ol className="flex items-center space-x-2">{children}</ol>
    </nav>
  );
};

export const BreadcrumbList = ({ children, className = '', ...props }) => {
  return (
    <ol className={`flex items-center space-x-2 ${className}`} {...props}>
      {children}
    </ol>
  );
};

export const BreadcrumbItem = ({ children, className = '', ...props }) => {
  return (
    <li className={`flex items-center ${className}`} {...props}>
      {children}
    </li>
  );
};

export const BreadcrumbLink = ({
  children,
  href,
  className = '',
  ...props
}) => {
  return (
    <a
      href={href}
      className={`text-blue-600 hover:text-blue-800 ${className}`}
      {...props}
    >
      {children}
    </a>
  );
};

export const BreadcrumbPage = ({ children, className = '', ...props }) => {
  return (
    <span className={`text-gray-500 ${className}`} {...props}>
      {children}
    </span>
  );
};

export const BreadcrumbSeparator = ({
  children = '/',
  className = '',
  ...props
}) => {
  return (
    <span className={`text-gray-400 mx-2 ${className}`} {...props}>
      {children}
    </span>
  );
};

export { Breadcrumb as default };
